import React from "react";

export default function AboutUs() {
  return (
    <div className="centered-page">
      <h2>History of the Wyandotte Roosevelt Rowing Crew</h2>
      <p>
        {" "}
        Founded in 1941, the Wyandotte Roosevelt High School Crew is the oldest,
        still active High School rowing program in Michigan and one of the
        earliest in the country. The Bears won the Senior 8 at its first known
        regatta on July 4 of the same year. Wyandotte's crew competed throughout
        its early years in some of the most storied secondary school regattas
        across the US and Canada. We can trace our crew history back to early
        wins at the Canadian Schoolboy Regattas as early as 1947 & 1948, the
        Central State's regattas of the 40's, 50's, 60's and 70's, Stotesbury
        Cup Regatta wins in the 1990's, and was one of the crews competing in
        the Midwest Scholastic Rowing Association Championships from its
        inception. We continue this traditional of competitive rowing today. The
        Wyandotte Roosevelt crew is the embodiment of scrappy grit and
        determination, often competing against schools with far greater
        resources and support. The crew is and has been a source of pride for
        the Wyandotte community as a whole, fostering a strong sense of
        camaraderie and teamwork among its members. We strive to
        keep the barriers to entry low and make the sport accessible to all
        interested athletes.
      </p>
      <h2>Our Mission</h2>
      <p>
        {" "}
        Carry on the proud tradition of accessible and competitive rowing in
        Wyandotte and to preserve the legacy of our program for future
        generations.{" "}
      </p>
      <h2>Our Fleet</h2>
      <p> Coming Soon... </p>
    </div>
  );
}
